import React, { useCallback, useContext, useEffect, useState } from 'react'
import { observer } from 'mobx-react-lite'

// evertel
import { Icon } from '@evertel/web/ui'
import { useService } from '@evertel/di'
import { SessionService } from '@evertel/session/SessionService'
import { RoomContext } from '../RoomContext'
import { Links } from '@evertel/constants'

const getStorageKey = (userId: number, roomId: number) =>
    `connector-banner-dismissed:${userId}:${roomId}`

const RoomConnectorsBanner: React.FC = observer(() => {

    const { roomController, roomConnectorsController } = useContext(RoomContext)
    const sessionService = useService(SessionService, [])

    const [dismissed, setDismissed] = useState<boolean>(true)

    const roomId = roomController.roomId
    const userId = sessionService.currentUserId
    const isRoomConnectorsInitialized = roomConnectorsController.roomId === roomId

    const handleDismiss = useCallback(() => {
        if (userId && roomId) {
            localStorage.setItem(getStorageKey(userId, roomId), 'true')
        }
        setDismissed(true)
    }, [userId, roomId])

    useEffect(() => {
        if (!userId || !roomId) return
        setDismissed(true) //sync with mobile
        const value = localStorage.getItem(getStorageKey(userId, roomId))
        setDismissed(value === 'true')
    }, [userId, roomId])

    // Clear dismissal when all connectors are disabled
    useEffect(() => {
        if (!userId || !roomId || !isRoomConnectorsInitialized ) return

        if (!roomConnectorsController.hasActiveConnectors) {
            // console.log(`Clearing for ${roomId}`)
            //be explicit that active connectors is the trigger
            localStorage.removeItem(getStorageKey(userId, roomId))
            setDismissed(false)
        }
    }, [isRoomConnectorsInitialized, roomConnectorsController, userId, roomId])

    // console.log(roomId, {isRoomConnectorsInitialized, hasActiveConnectors: roomConnectorsController?.hasActiveConnectors, dismissed})
    if (!isRoomConnectorsInitialized || !roomConnectorsController.hasActiveConnectors || dismissed) {
        return null
    }
    // console.log('Showing Banner')

    return (
        <div className="connectors-banner">
            <div className="connectors-banner-content">
                <strong>Connectors are active in this room.</strong>
                {' '}Anything posted here may be sent outside of Evertel.{' '}
                <a
                    href={Links.helpConnectors}
                    target="_blank"
                    rel="noopener noreferrer"
                    style={{color: 'currentColor', textDecoration: 'underline'}}
                >
                    Learn more
                </a>
            </div>
            <button
                className="connectors-banner-close"
                onClick={handleDismiss}
                aria-label="Dismiss connector warning"
            >
                <Icon name="xmark" />
            </button>
        </div>
    )
})

RoomConnectorsBanner.displayName = 'RoomConnectorsBanner'

export { RoomConnectorsBanner }
